// extracted by mini-css-extract-plugin
export default {"custom-error":"index-module__custom-error--lB3Jo","custom-error--anim":"index-module__custom-error--anim--56NTu","spinner-box":"index-module__spinner-box--xIn1F"};